<div class="channel-code">

  <div class="triangle-with-shadow"></div>
  <header class="flex row space-between">
    <div class="flex column">DOWNLOAD CHANNEL'S 24/7 RECORDS</div>
    <div
      class="close-sign flex column"
      [inlineSVG]="closeIcon"
      (click)="onCloseButtonClicked($event)"
    ></div>
  </header>
  <section>
    <p>Channel: {{channel.name}}</p>
    <div class="availability-zones-filter field">
      <label class="label flex column">Choose Availability Zone:</label>
      <icn-dropdown
        [position]="'bottom'"
        [allowMultiple]="false"
        class="flex column"
        [(selectedValue)]="selectedAvailabilityZoneId"
      >
        <icn-dropdown-item
          *ngFor="let zone of allChannelAvailabilityZone"
          [value]="zone.id"
          [title]="zone.displayName"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="date-filter field">
      <label class="label">Choose Date (UTC):</label>
      <dateinput
        [(current)]="dateFilterTime"
        [datePickerOverrideStyle]="{'top': '1vh'}"
      ></dateinput>
    </div>
    <div class="time-filters flex row space-between  field" *ngIf="showTimeFilters">
      <div class="time-from-filter flex column">
        <label class="label">Choose Time From (UTC):</label>
        <icn-time-picker
          class="time-picker"
          [(timeInMinutes)]="fromTimeMinutes"
        ></icn-time-picker
        >
      </div>
      <div class="time-to-filter flex column">
        <label class="label">Choose Time To (UTC):</label>
        <icn-time-picker
          class="time-picker"
          [(timeInMinutes)]="toTimeMinutes"
        ></icn-time-picker
        >
      </div>

    </div>
    <p class="response-message">
      {{responseMessage}}
    </p>
    <p class="buttons">
      <button (click)="onDownloadClicked($event)">Download</button>
    </p>
  </section>
</div>
